module.exports = __webpack_public_path__ + "img/team-list4.45d2d324.png";